export function buildEdgeFunctionErrorMessage(error: unknown, fallbackMessage: string) {
  if (!error || typeof error !== "object") {
    return fallbackMessage;
  }

  const message = "message" in error ? String(error.message || "") : "";
  const normalizedMessage = message.toLowerCase();

  if (
    normalizedMessage.includes("failed to send a request to the edge function")
    || normalizedMessage.includes("failed to fetch")
    || normalizedMessage.includes("network")
  ) {
    return "We could not reach that service right now. Please try again in a moment.";
  }

  if (normalizedMessage.includes("non-2xx status code")) {
    return fallbackMessage;
  }

  return message || fallbackMessage;
}
